module.exports = __webpack_public_path__ + "img/stadia-ios-loading-framed_2x.12916d44.webp";